import _ from 'lodash';
import { COOKIE_EXPIRY_WITH_SESSION } from '../../../constants/defaults';
import bffcli from '../bffcli';

const errorHandler = err => {
  console.log(err);
};

export async function getLocationByZipCode(zipCode) {
  try {
    const locationResponse = await bffcli.post('/location/get-for-zipcode', {
      zipCode: zipCode
    });
    if (locationResponse) {
      return locationResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export async function getLocationByCity(data) {
  try {
    const { query, latitude, longitude } = data;
    let url = `/location/get-for-city?q=${query}`;
    if (
      latitude != null &&
      !Number.isNaN(latitude) &&
      longitude != null &&
      !Number.isNaN(longitude)
    )
      url += `&lat=${latitude}&lon=${longitude}`;
    const locationResponse = await bffcli.get(url);
    if (locationResponse) {
      return locationResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export async function getIp() {
  try {
    const locationResponse = await bffcli.get('/location/getIp', {
      withCredentials: true
    });
    if (locationResponse) {
      return locationResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export async function getIpAddress() {
  try {
    const locationResponse = await bffcli.get('/location/getIp/getAddress', {
      withCredentials: true
    });
    if (locationResponse && !_.isEmpty(locationResponse.data)) {
      _.setCookie(
        'ipAddress',
        locationResponse.data.ipAddress,
        COOKIE_EXPIRY_WITH_SESSION
      );
      return locationResponse.data.ipAddress;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export const sanitizeQuery = query => {
  return query.replace(/[^a-zA-Z0-9 ,_-]/g, '').trim();
};

export async function fetchDrugs(drugName) {
  const headers = {
    'X-ProspectID': _.getCookie('prospect-id'),
    'X-SessionID': _.getCookie('session-guid')
  };

  const drugResponse = await bffcli.post(
    '/search-drugs',
    {
      query: sanitizeQuery(drugName)
    },
    {
      withCredentials: true,
      headers
    }
  );

  if (
    drugResponse &&
    !_.isEmpty(drugResponse.data) &&
    !_.isEmpty(drugResponse.data.results)
  ) {
    return drugResponse.data.results;
  }

  throw new Error('API did not return any data.');
}

export async function fetchPopularDrugs(dataBy = 'script') {
  try {
    const popularDrugsResponse = await bffcli.get(
      `/top-prescription?dataBy=${dataBy}`,
      // `${API.GO_SERVER}/druginformation/v2/GetTopPrescription`,
      { withCredentials: true }
    );

    if (
      popularDrugsResponse &&
      !_.isEmpty(popularDrugsResponse.data) &&
      !_.isEmpty(popularDrugsResponse.data.results)
    ) {
      return popularDrugsResponse.data.results;
    }

    throw new Error('API did not return any data.');
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export const getLocationUsingCoordinates = async coordinatesData => {
  try {
    const getLocationUsingCoordinatesResponse = await bffcli.post(
      '/location/get-for-coordinated',
      coordinatesData,
      { withCredentials: true }
    );
    if (getLocationUsingCoordinatesResponse) {
      return getLocationUsingCoordinatesResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};
